import React, {Component} from 'react';
import { Route } from 'react-router-dom';
import { Row } from 'simple-flexbox';

import API from '@modules/softwareIntegration/API';
import APIData from '@modules/apiData/APIData';
import BankCodes from '@modules/bankCodes/BankCodes';
import EmptyScreen from '@components/EmptyScreen';
import GenerateReport from '@modules/generateReport/GenerateReport';
import MyAccount from '@modules/myAccount/MyAccount';
import Refunds from '@modules/refunds/Refunds';
import RequestSettlement from '@modules/finances/RequestSettlement';

import { crudActions } from '@sm/services/crudActions';
import { FETCH_PERMISSIONS } from '@sm/actions/types';
const combineReducers =  require('@sm/reducers/index');

class Module extends Component {
  state = {
    permissions: [],
    roleId: ""
  };

  componentDidMount() {
    crudActions.get(`v1/myaccount/me`).then(
      (user) => {
        if (user) {
          combineReducers.default.dispatch({ type: FETCH_PERMISSIONS, payload: user.permissions, roleId: user.roleId, wlOtcEnabled: user.wlOtcEnabled });
          this.setState({
            permissions: user.permissions,
            roleId: user.roleId,
            wlOtcEnabled: user.wlOtcEnabled
          });
        }
      }
    ).catch(
      err => {
        localStorage.removeItem("loginAsUser");
        localStorage.removeItem("loginAsUserEmail");
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message,
          });
        }
      }
    );
  };

  checkPageAccess = (permissionName, url) => {
    const { permissions, wlOtcEnabled } = this.state;
    if (url === "/otc-settlement") {
      return wlOtcEnabled;
    } else if (url === "/request-settlement" && wlOtcEnabled) {
      return false;
    }
    const foundPermission = permissions.find(elem => elem.permission === permissionName);
    if (!foundPermission) {
      return false;
    }

    return foundPermission.state;
  };

  checkPageAccessCategory = (categoryName, isOtc) => {
    const { permissions } = this.state;
    const foundPermissions = permissions.filter(elem => elem.category === categoryName);
    return foundPermissions.some(elem => elem.state);
  };

  checkRole = (roleName) => {
    const { roleId } = this.state;
    return roleId === roleName;
  };

  render() {

    return (
      <Row flexGrow={ 1 }>
        <Route exact path="/" component={ EmptyScreen }/>
        <Route exact path="/my-account" component={ MyAccount }/>
        <Route exact path="/docs" component={ API }/>
        { this.checkPageAccessCategory("REFUND") && <Route exact path="/refunds" component={ Refunds }/> }
        { this.checkPageAccessCategory("DASHBOARD") && <Route exact path="/dashboard" component={ APIData }/> }
        { this.checkPageAccessCategory("REPORTS") && <Route exact path="/generate-reports" component={ GenerateReport }/> }
        { this.checkPageAccess("REQUEST_SETTLEMENT", "/request-settlement") && <Route exact path="/request-settlement" component={ RequestSettlement } /> }
        { this.checkPageAccess("REQUEST_SETTLEMENT", "/otc-settlement") && <Route exact path="/otc-settlement" component={ RequestSettlement } /> }
        { this.checkPageAccessCategory("BANKLIST") && <Route exact path="/bank-codes" component={ BankCodes } /> }
      </Row>
    );
  }
}

export default Module;